import type { CountryCode } from '~/api/common/types';

import { flagStyle } from './CountryFlag.css';

const CDN_URL = 'https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/';

type Props = {
  countryCode: CountryCode | 'XX';
};

export const CountryFlag = ({ countryCode }: Props) => {
  const url = `${CDN_URL}${countryCode.toLowerCase()}.svg`;

  return <img alt={countryCode} className={flagStyle} loading="lazy" src={url} />;
};
